import React from "react";
import {
  AppBar,
  Button,
  createStyles,
  makeStyles,
  Slide,
  Toolbar,
  Typography,
} from "@material-ui/core";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    appbar: {
      zIndex: 501,
      marginTop: theme.mixins.toolbar.minHeight,
    },
    toolbar: {
      display: "flex",
      justifyContent: "center",
    },
    orange: {
      backgroundColor: "#f37424",
    },
    white: {
      backgroundColor: "#ffffff",
    },
    word: {
      marginRight: theme.spacing(1),
    },
    button: {
      fontSize: 18,
      color: "#5d5d5d",
    },
  })
);

export default function Update({ show, onUpdate }) {
  const classes = useStyles();

  return (
    <Slide in={show} direction="down">
      <AppBar
        className={classes.appbar}
        classes={{ colorPrimary: classes.orange }}
        elevation={1}
      >
        <Toolbar variant="dense" className={classes.toolbar}>
          <Typography
            variant="overline"
            className={classes.word}
            color="inherit"
          >
            アプリを更新してください
          </Typography>
          <Button
            variant="contained"
            size="small"
            onClick={onUpdate}
            color="inherit"
            classes={{ colorInherit: classes.white }}
            className={classes.button}
            disableElevation
          >
            OK
          </Button>
        </Toolbar>
      </AppBar>
    </Slide>
  );
}
